import { combineReducers } from 'redux';
import warranty from './warranty';

export default combineReducers({
  warranty,
});
